/**
 * Thin wrapper around chartPalette for API stability.
 * Legacy consumers can keep calling getCompanyColor(index).
 */

import { getChartColor } from "@/composables/chartPalette";

export function getCompanyColor(index: number): string {
  if (typeof index !== "number") {
    throw new RangeError("Index must be a number");
  }
  if (!Number.isFinite(index)) {
    throw new RangeError("Index must be a finite number");
  }
  if (index < 0) {
    throw new RangeError("Index must be non-negative");
  }
  if (!Number.isInteger(index)) {
    throw new RangeError("Index must be an integer");
  }

  return getChartColor({ index });
}
